(function () {
  const calcMinHeight = () => {
    const facetsTop = document.querySelector('.facets__top');
    const sortWrapper = document.querySelector('.facets__sort-wrapper');
    const collectionWrapper = document.querySelector('.collection-wrapper');

    if (facetsTop && sortWrapper && collectionWrapper) {
      collectionWrapper.style.gridTemplateRows =  sortWrapper.getBoundingClientRect().height+'px auto 1fr';
    }
  }

  const resizeCollectionGrid = () => {
		const collectionGridSection = document.querySelector('.collection-grid-section') || document.querySelector('.section-search');

		const sectionResizeObserver = new ResizeObserver((entries) => {

			const [entry] = entries;
      calcMinHeight();
		});

		sectionResizeObserver.observe(collectionGridSection);
	}

  document.addEventListener('shopify:section:load', function () {
		resizeCollectionGrid();
	});

	resizeCollectionGrid();

    
})();

(function () {
	const ROOT_MARGIN = "0px 0px 800px 0px";
	let observer;
	let requestController;
	let generation = 0;
	let isLoading = false;
	const requestedUrls = new Set();

	const disconnect = () => {
		generation += 1;
		observer?.disconnect();
		observer = undefined;
		requestController?.abort();
		requestController = undefined;
		isLoading = false;
	};

	const getProductKey = (item) => {
		const productLink = item.querySelector('a[href*="/products/"]');
		if (!productLink) return null;

		try {
			return new URL(productLink.href, window.location.origin).pathname;
		} catch (error) {
			return productLink.getAttribute("href");
		}
	};

	const reinitializeProductCards = () => {
		if (typeof colorSwatches === "function") colorSwatches();
		if (typeof loadeMoreSlider_G === "function") loadeMoreSlider_G();
	};

	const loadNextPage = async (sentinel, container, instanceGeneration) => {
		if (isLoading || instanceGeneration !== generation) return;

		const data = sentinel.previousElementSibling;
		const nextUrlInput = data?.querySelector("[data-next-url]");
		const nextUrl = nextUrlInput?.value;
		if (!nextUrl) {
			data?.remove();
			sentinel.remove();
			return;
		}
		if (requestedUrls.has(nextUrl)) return;

		isLoading = true;
		requestedUrls.add(nextUrl);
		sentinel.classList.add("loading");
		requestController = new AbortController();

		try {
			const response = await fetch(nextUrl, {
				signal: requestController.signal,
				headers: { "X-Requested-With": "XMLHttpRequest" },
			});
			if (!response.ok) throw new Error(`HTTP ${response.status}`);

			const documentFragment = new DOMParser().parseFromString(
				await response.text(),
				"text/html"
			);
			const nextContainer = documentFragment.getElementById("ProductGridContainer");
			const nextGrid = nextContainer?.querySelector("#product-grid");
			const currentGrid = container.querySelector("#product-grid");

			if (
				instanceGeneration !== generation ||
				!container.isConnected ||
				document.getElementById("ProductGridContainer") !== container ||
				!nextGrid ||
				!currentGrid
			) {
				return;
			}

			const existingProducts = new Set(
				Array.from(currentGrid.querySelectorAll(".collection-product-card"))
					.map(getProductKey)
					.filter(Boolean)
			);

			Array.from(nextGrid.children).forEach((item) => {
				if (item.classList.contains("collection-product-promo-img")) return;

				const productKey = getProductKey(item);
				if (productKey && existingProducts.has(productKey)) return;
				if (productKey) existingProducts.add(productKey);
				currentGrid.appendChild(document.importNode(item, true));
			});

			const nextData = nextContainer.querySelector(".infinite-scroll__data");
			const nextSentinel = nextContainer.querySelector(".js-infinite-scroll");

			if (nextData && nextSentinel) {
				data.replaceWith(document.importNode(nextData, true));
				sentinel.replaceWith(document.importNode(nextSentinel, true));
			} else {
				data?.remove();
				sentinel.remove();
			}

			reinitializeProductCards();
		} catch (error) {
			requestedUrls.delete(nextUrl);
			if (error.name !== "AbortError") {
				console.error("Collection infinite scroll failed:", error);
			}
		} finally {
			if (instanceGeneration === generation) {
				isLoading = false;
				requestController = undefined;
				window.loadMore();
			}
		}
	};

	window.loadMore = function loadMore() {
		disconnect();
		requestedUrls.clear();

		const container = document.getElementById("ProductGridContainer");
		const sentinel = container?.querySelector(".js-infinite-scroll");
		if (!container || !sentinel || !("IntersectionObserver" in window)) return;

		const instanceGeneration = generation;
		observer = new IntersectionObserver(
			(entries) => {
				if (!entries.some((entry) => entry.isIntersecting)) return;
				observer?.disconnect();
				loadNextPage(sentinel, container, instanceGeneration);
			},
			{ root: null, rootMargin: ROOT_MARGIN, threshold: 0 }
		);
		observer.observe(sentinel);
	};

	document.addEventListener("DOMContentLoaded", window.loadMore);
	document.addEventListener("shopify:section:load", window.loadMore);
})();
